import { render, staticRenderFns } from "./ViewManageList.vue?vue&type=template&id=24f1b5a7&scoped=true&"
import script from "./ViewManageList.vue?vue&type=script&lang=js&"
export * from "./ViewManageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f1b5a7",
  null
  
)

export default component.exports